import moment from "moment";
import React from "react";
import { Link } from "react-router-dom";
import { Button } from "reactstrap";
import DollarIcon from "../Icons/DollarIcon";
import PdfIcon from "../Icons/PdfIcon";
import EyeIcon from "../Icons/EyeIcon";
import PencilIcon from "../Icons/PencilIcon";
import PadLockIcon from "../Icons/PadLockIcon";
import PadUnlockIcon from "../Icons/PadUnlockIcon";
import IncloudIcon from "../Icons/IncloudIcon";
import { idAdministrador, idTransportista } from "../Utility/roles";

const Columns = (
  view,
  handleReactivarViaje,
  onControl,
  valorization,
  handleActivate,
  role,
  handleOpenDocument,
  handleDesasociarDocumento
) => [
  {
    dataField: "menu",
    isDummyField: true,
    text: "Acciones",
    style: { width: "5%" },

    formatter: (cellContent, row) => {
      return (
        <>
          <div
            key={`outboundcolumns_${row?.id}`}
            className="btn-group  mt-md-0"
            size="sm"
            role="group"
          >
            {role.id !== idTransportista && (
              <Button
                style={{ padding: "0.5em" }}
                disabled={
                  !(row?.estado == "Completo" || row?.estado == "Aceptado")
                }
                title="Visualizar documentos"
                onClick={() => handleOpenDocument(row)}
                type="button"
                color="light"
              >
                <EyeIcon width="20px" />
              </Button>
            )}

            {/* { role.name === 'Admin' && (row?.estado === "Completo" ||
              row?.estado === "No Asignado" ||
              row?.estado === "Ingresado") && ( */}
            {(role.id === idTransportista || role.id === idAdministrador ) &&
              (row?.estado === "Completo" ||
                row?.estado === "No Asignado" ||
                row?.estado === "Ingresado") && (
                <Button
                  style={{ padding: "0.5em" }}
                  title="Sin operación"
                  type="button"
                  color="light"
                  disabled
                >
                  <PadUnlockIcon width="20px" />
                </Button>
              )}


            {(role.id === idTransportista || role.id === idAdministrador )&&
              (row?.estado == "Aceptado" || row?.estado == "Rechazado") && (
              // {role.name === 'Admin' && (row?.estado == "Aceptado" ||
              // row?.estado == "Rechazado")  && (
                <Button
                  style={{ padding: "0.5em" }}
                  title="Reactivar el viaje"
                  onClick={() => {
                    if (row?.estado == "Rechazado")
                      handleReactivarViaje(row.id);
                  }}
                  type="button"
                  color="light"
                  disabled={row?.estado == "Aceptado"}
                >
                  <PadLockIcon width="20px" />
                </Button>
              )}

            {(role.id === idTransportista || role.id === idAdministrador ) && (
            // {role.name  === 'Admin' &&(
              <Button
                style={{ padding: "0.5em" }}
                disabled={!(row?.estado == "Ingresado")}
                title="Desasociar"
                onClick={() => handleDesasociarDocumento(row.id)}
                type="button"
                color="light"
              >
                Desasociar
              </Button>
            )}
          </div>
        </>
      );
    },
  },
  {
    dataField: "nroDocument",
    text: "N. Doc",
    sort: true,
    style: { width: "5%" },
    sortCaret: (order, column) => {
      if (!order) return <span>&nbsp;&#8597;</span>;
      else if (order === "asc") return <span>&nbsp;&#8593;</span>;
      else if (order === "desc") return <span>&nbsp;&#8595;</span>;
      return null;
    },
  },

  {
    dataField: "providerName",
    text: "Proveedor",
    sort: true,
    style: { width: "5%" },
    sortCaret: (order, column) => {
      if (!order) return <span>&nbsp;&#8597;</span>;
      else if (order === "asc") return <span>&nbsp;&#8593;</span>;
      else if (order === "desc") return <span>&nbsp;&#8595;</span>;
      return null;
    },
  },
  {
    dataField: "pInsumo",
    text: "P. Ínsumo.",
    sort: true,

    style: { width: "5%" },
    sortCaret: (order, column) => {
      if (!order) return <span>&nbsp;&#8597;</span>;
      else if (order === "asc") return <span>&nbsp;&#8593;</span>;
      else if (order === "desc") return <span>&nbsp;&#8595;</span>;
      return null;
    },
  },
  {
    dataField: "qDoc",
    text: "Q. Doc",
    sort: true,
    style: { width: "5%" },
    sortCaret: (order, column) => {
      if (!order) return <span>&nbsp;&#8597;</span>;
      else if (order === "asc") return <span>&nbsp;&#8593;</span>;
      else if (order === "desc") return <span>&nbsp;&#8595;</span>;
      return null;
    },
  },

  {
    dataField: "date",
    text: "Fecha",
    sort: true,
    style: { width: "5%" },
    formatter: (cellContent, row) => moment(cellContent).format("DD-MM-YYYY"),
    sortCaret: (order, column) => {
      if (!order) return <span>&nbsp;&#8597;</span>;
      else if (order === "asc") return <span>&nbsp;&#8593;</span>;
      else if (order === "desc") return <span>&nbsp;&#8595;</span>;
      return null;
    },
  },

  {
    dataField: "peso",
    text: "Peso",
    sort: true,
    style: { width: "5%" },
    sortCaret: (order, column) => {
      if (!order) return <span>&nbsp;&#8597;</span>;
      else if (order === "asc") return <span>&nbsp;&#8593;</span>;
      else if (order === "desc") return <span>&nbsp;&#8595;</span>;
      return null;
    },
  },
  {
    dataField: "estado",
    text: "Estado",
    sort: true,
    style: { width: "5%" },
    formatter: (cell, row) => (
      <p
        className="m-1"
      >
        {cell}{" "}
        {cell === "Rechazado" && row?.obervation && (
          <i
            title={row?.obervation}
            className="mdi mdi-information-outline font-size-16 text-warning"
          ></i>
        )}{" "}
      </p>
    ),
    sortCaret: (order, column) => {
      if (!order) return <span>&nbsp;&#8597;</span>;
      else if (order === "asc") return <span>&nbsp;&#8593;</span>;
      else if (order === "desc") return <span>&nbsp;&#8595;</span>;
      return null;
    },
  },
  {
    dataField: "isAssigned",
    text: "Asignado",
    sort: true,

    style: { width: "5%" },
    formatter: (cell) => (cell ? "Si" : "No"),
    sortCaret: (order, column) => {
      if (!order) return <span>&nbsp;&#8597;</span>;
      else if (order === "asc") return <span>&nbsp;&#8593;</span>;
      else if (order === "desc") return <span>&nbsp;&#8595;</span>;
      return null;
    },
  },

  {
    dataField: "scan",
    text: "Scan",
    sort: true,

    style: { width: "5%" },
    formatter: (cell) => (cell ? "Si" : "No"),
    sortCaret: (order, column) => {
      if (!order) return <span>&nbsp;&#8597;</span>;
      else if (order === "asc") return <span>&nbsp;&#8593;</span>;
      else if (order === "desc") return <span>&nbsp;&#8595;</span>;
      return null;
    },
  },
  {
    dataField: "ctrlVisual",
    text: "Ctrl. Visual",
    sort: true,

    style: { width: "5%" },
    formatter: (cell) => (cell ? "Si" : "No"),
    sortCaret: (order, column) => {
      if (!order) return <span>&nbsp;&#8597;</span>;
      else if (order === "asc") return <span>&nbsp;&#8593;</span>;
      else if (order === "desc") return <span>&nbsp;&#8595;</span>;
      return null;
    },
  },
];

export default Columns;
